function buildExpiry(days) {
  if (typeof days !== "number") {
    return "";
  }

  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  return `; expires=${date.toUTCString()}`;
}

function buildDomain(domain) {
  if (typeof domain !== "string" || domain.trim().length === 0) {
    return "";
  }

  return `; domain=${domain.trim()}`;
}

export function readCookie(name) {
  if (typeof document === "undefined") {
    return null;
  }

  const encodedName = `${encodeURIComponent(name)}=`;
  const entry = document.cookie.split("; ").find(cookie => cookie.startsWith(encodedName));

  if (!entry) {
    return null;
  }

  try {
    return decodeURIComponent(entry.slice(encodedName.length));
  } catch (_error) {
    return null;
  }
}

export function setCookie(name, value, days, options = {}) {
  if (typeof document === "undefined") {
    return;
  }

  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value || "")}${buildExpiry(
    days
  )}; path=/${buildDomain(options.domain)}; SameSite=Lax`;
}

export function clearCookie(name, options = {}) {
  setCookie(name, "", -1, options);

  if (options.domain) {
    setCookie(name, "", -1);
  }
}
